/*
  Icon Walls — PDP v2 (Launch)
  Vanilla, keine externen Abhängigkeiten. Klinkt sich in Dawns <product-form> ein.
  Zuständig für: Variant-Matching (Preis/Verfügbarkeit/ATC/Galerie), Sticky-ATC-Sync,
  cm/Zoll-Umschalter, Deep-Link (?variant=), Bundle-Mengen, Zoom-Lightbox.
*/
(function () {
  'use strict';

  var CM_TO_IN = 0.3937007874;

  function money(el) { return el ? el.getAttribute('data-money') : ''; }

  function initPdp(root) {
    var dataEl = root.querySelector('[data-mp-variants]');
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    var idInput = root.querySelector('[data-mp-variant-id]');
    var qtyInput = root.querySelector('[data-mp-qty]');
    var priceEl = root.querySelector('[data-mp-price]');
    var compareEl = root.querySelector('[data-mp-compare]');
    var unitEl = root.querySelector('[data-mp-unit]');
    var submitBtn = root.querySelector('[data-mp-atc]');
    var submitText = submitBtn ? submitBtn.querySelector('[data-mp-atc-text]') : null;
    var strings = window.variantStrings || {};
    // Limitierte Auflage komplett verkauft (Server-Flag): ATC bleibt IMMER deaktiviert,
    // auch wenn einzelne Varianten wegen "Weiterverkauf erlauben" formal verfuegbar sind.
    var editionSoldout = root.hasAttribute('data-mp-edition-soldout');

    var stickyPrice = document.querySelector('[data-mp-sticky-price]');
    var stickyThumb = document.querySelector('[data-mp-sticky-thumb]');
    var stickyVariant = document.querySelector('[data-mp-sticky-variant]');
    // Robin (2026-07-31): Sticky-Button beim Variantenwechsel mitschalten. Sein
    // disabled kam bisher nur aus dem Server-Render (sticky-atc.liquid) — wer von
    // einer verfuegbaren auf eine nicht verfuegbare Variante wechselte, sah unten
    // weiter einen aktiven Kauf-Button. Shopify lehnt den Add zwar ab (422),
    // aber der Button darf gar nicht erst klickbar wirken.
    var stickyBtn = document.querySelector('[data-mp-sticky] .mp-sticky__btn');

    var sizeNotes = {};
    var notesEl = root.querySelector('[data-mp-size-notes]');
    if (notesEl) { try { sizeNotes = JSON.parse(notesEl.textContent); } catch (e) {} }

    var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-mp-option]'));

    function selectedOptions() {
      return optionGroups.map(function (g) {
        var c = g.querySelector('input:checked');
        return c ? c.value : null;
      });
    }

    function findVariant(sel) {
      var hit = variants.find(function (v) {
        return v.options.length === sel.length && v.options.every(function (o, i) { return o === sel[i]; });
      });
      if (hit) return hit;
      // Produkte OHNE Optionsauswahl (Einzelvariante, Shopify-Option "Default Title"):
      // Es wird kein Picker gerendert, sel ist also leer, waehrend die Variante eine
      // Option traegt — das Matching oben scheitert zwangslaeufig und der Button blieb
      // faelschlich auf "Nicht verfuegbar" stehen. Dann ist die einzige (bzw. erste
      // verfuegbare) Variante die richtige.
      if (!optionGroups.length && variants.length) {
        return variants.find(function (v) { return v.available; }) || variants[0];
      }
      return undefined;
    }

    function currentBundleQty() {
      var b = root.querySelector('[data-mp-bundle] input:checked');
      return b ? parseInt(b.value, 10) || 1 : 1;
    }

    function fmtMoneyTimes(cents, qty) {
      // Build a rough total string using the variant's formatted price is not trivial;
      // we rely on server-provided per-variant formatted price and show unit×qty in text.
      return null;
    }

    function materialGroupIndex() {
      for (var i = 0; i < optionGroups.length; i++) {
        if (optionGroups[i].getAttribute('data-mp-option') === 'material') return i;
      }
      return -1;
    }

    /* Kontextabhängige Optionen (POD-Logik):
       - Material nur durchstreichen, wenn es in KEINER Variante verfügbar ist (nichts fälschlich „ausverkauft").
       - Andere Achsen (z. B. eine „Style"-Achse) zeigen nur Werte, die es zum gewählten Material gibt;
         der Platzhalter „-" wird versteckt (bzw. als „Standard" beschriftet, falls er neben echten Werten steht).
       - Achsen ohne echte Wahl werden komplett ausgeblendet. */
    function updateAvailabilityHints() {
      var sel = selectedOptions();
      var mgi = materialGroupIndex();
      optionGroups.forEach(function (group, gi) {
        if (gi === mgi) {
          group.querySelectorAll('input').forEach(function (input) {
            var ok = variants.some(function (v) { return v.options[gi] === input.value && v.available; });
            var label = input.closest('.mp-opt') || input.nextElementSibling;
            if (label) label.classList.toggle('is-unavailable', !ok);
          });
          return;
        }
        var valid = {};
        variants.forEach(function (v) {
          if (!v.available) return;
          if (mgi !== -1 && sel[mgi] != null && v.options[mgi] !== sel[mgi]) return;
          valid[v.options[gi]] = true;
        });
        var realChoices = 0;
        Object.keys(valid).forEach(function (k) { if (k !== '-') realChoices++; });
        group.querySelectorAll('input').forEach(function (input) {
          var label = input.closest('.mp-opt') || input.nextElementSibling;
          if (!label) return;
          label.classList.remove('is-unavailable');
          var isValid = !!valid[input.value];
          var isPlaceholder = input.value === '-';
          var show = isValid && !(isPlaceholder && realChoices === 0);
          if (isPlaceholder && isValid && realChoices > 0) {
            var txt = label.querySelector('.mp-opt__label');
            if (txt && !txt.dataset.origLabel) { txt.dataset.origLabel = txt.textContent; txt.textContent = 'Standard'; }
          }
          label.hidden = !show;
        });
        group.hidden = realChoices === 0;
      });
    }

    /* Ergibt die aktuelle Auswahl keine existierende Variante (z. B. Leinwand braucht Style Slim/Thick),
       automatisch auf die nächstliegende verfügbare Kombination mit dem neu gewählten Wert umspringen. */
    function snapToValid(gi, val) {
      if (findVariant(selectedOptions())) return;
      var sel = selectedOptions();
      var best = null;
      var bestScore = -1;
      variants.forEach(function (v) {
        if (v.options[gi] !== val) return;
        var s = v.available ? 100 : 0;
        v.options.forEach(function (o, i) {
          if (i === gi) return;
          if (o === sel[i]) s += optionGroups[i] && optionGroups[i].getAttribute('data-mp-option') === 'size' ? 10 : 1;
        });
        if (s > bestScore) { bestScore = s; best = v; }
      });
      if (!best) return;
      optionGroups.forEach(function (g, i) {
        if (i === gi) return;
        var input = Array.prototype.find.call(g.querySelectorAll('input'), function (inp) { return inp.value === best.options[i]; });
        if (input) input.checked = true;
      });
    }

    function updateSizeNote(sel) {
      var out = root.querySelector('[data-mp-size-note-out]');
      if (!out) return;
      var text = '';
      optionGroups.forEach(function (g, gi) {
        if (g.getAttribute('data-mp-option') === 'size' && sel[gi] && sizeNotes[sel[gi]]) text = sizeNotes[sel[gi]];
      });
      out.textContent = text;
      out.hidden = text === '';
    }

    function setGallery(mediaId) {
      if (mediaId == null) return;
      var g = document.querySelector('[data-mp-gallery]');
      if (!g) return;
      var thumb = g.querySelector('[data-media-id="' + mediaId + '"]');
      if (thumb) thumb.click();
    }

    /* Gelato-Produkte haben KEINE Varianten-Bilder (mediaId = null) — dort liefert
       das Galerie-Alt-Schema „Titel – Material" das richtige Bild (dieselbe Quelle
       wie der Homepage-Material-Filter). Reihenfolge der Keywords beachten:
       „– Aluminium" MIT Gedankenstrich, sonst matcht „Gebürstetes Aluminium". */
    var MAT_ALT_KEYS = {
      'canvas': ['Leinwand (Slim)', 'Leinwand'],
      'acrylic print': ['Acrylglas'],
      'aluminum print': ['– Aluminium'],
      'brushed aluminum print': ['Gebürstetes Aluminium'],
      'museum-quality matte paper metal framed poster': ['Museumsposter'],
      'premium semi-glossy paper metal framed poster': ['Gerahmtes Poster'],
      'premium matte paper metal framed poster': ['Gerahmtes Poster'],
      'classic semi-glossy paper metal framed poster': ['Gerahmtes Poster'],
      'classic matte paper metal framed poster': ['Gerahmtes Poster']
    };
    function galleryMediaForMaterial(matVal) {
      var keys = MAT_ALT_KEYS[(matVal || '').toLowerCase().trim()];
      if (!keys) return null;
      var g = document.querySelector('[data-mp-gallery]');
      if (!g) return null;
      var thumbs = g.querySelectorAll('[data-media-id]');
      for (var k = 0; k < keys.length; k++) {
        for (var i = 0; i < thumbs.length; i++) {
          var img = thumbs[i].querySelector('img');
          if (img && img.alt && img.alt.indexOf(keys[k]) !== -1) {
            return thumbs[i].getAttribute('data-media-id');
          }
        }
      }
      return null;
    }

    /* ---- Thumbnails auf das gewaehlte Material begrenzen (Robin, 2026-07-31) ----
       Problem vorher: man konnte Acryl waehlen und trotzdem das Leinwand-Thumb
       anklicken — Hauptbild und Materialwahl liefen auseinander.
       Regel: Bilder, deren Alt-Text KEIN Material-Keyword enthaelt (Raum-Mockups
       „– Ambiente: …“, freigestellte Motive), bleiben IMMER sichtbar und waehlbar.
       Material-Aufnahmen erscheinen nur beim passenden Material.
       Zwei Sicherungen gegen Leer-Galerien: unbekanntes Material oder ein Produkt
       ganz ohne erkennbare Material-Bilder -> es wird nichts ausgeblendet. */
    var ALL_MAT_KEYS = Object.keys(MAT_ALT_KEYS).reduce(function (acc, k) {
      return acc.concat(MAT_ALT_KEYS[k]);
    }, []);

    function thumbAlt(thumb) {
      var img = thumb.querySelector('img');
      return (img && img.alt) || '';
    }
    function altMatches(alt, keys) {
      for (var i = 0; i < keys.length; i++) {
        if (alt.indexOf(keys[i]) !== -1) return true;
      }
      return false;
    }

    function filterThumbs(sel, keepActive) {
      var g = document.querySelector('[data-mp-gallery]');
      if (!g) return;
      var mgi = materialGroupIndex();
      if (mgi === -1) return;
      var keys = MAT_ALT_KEYS[(sel[mgi] || '').toLowerCase().trim()];
      if (!keys) return;
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-media-id]'));
      var hasMaterialShots = thumbs.some(function (t) {
        return altMatches(thumbAlt(t), ALL_MAT_KEYS);
      });
      if (!hasMaterialShots) return;
      thumbs.forEach(function (t) {
        var alt = thumbAlt(t);
        var show = !altMatches(alt, ALL_MAT_KEYS) || altMatches(alt, keys);
        // Beim Erstaufruf das kuratierte Hero-Thumb nie wegblenden (sonst waere
        // das aktive Bild unsichtbar) — siehe Kommentar bei setGallery.
        if (!show && keepActive && t.classList.contains('is-active')) show = true;
        var li = t.closest ? t.closest('li') : t.parentNode;
        (li || t).hidden = !show;
      });
    }

    function syncSticky(variant) {
      if (stickyPrice && variant.price) stickyPrice.innerHTML = variant.price;
      if (stickyVariant) {
        var qty = currentBundleQty();
        stickyVariant.textContent = variant.title + (qty > 1 ? ' · ' + qty + '×' : '');
      }
      if (stickyThumb && variant.thumb) stickyThumb.src = variant.thumb;
    }

    function updateDeepLink(variant) {
      if (!variant || !window.history || !history.replaceState) return;
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url.toString());
    }

    function sizeGroupIndex() {
      for (var i = 0; i < optionGroups.length; i++) {
        if (optionGroups[i].getAttribute('data-mp-option') === 'size') return i;
      }
      return -1;
    }

    /* Material-Karten zeigen den REALEN Preis des Materials im aktuell gewählten Format
       (nicht mehr „+X" gegenüber dem Basispreis). Aktualisiert bei jedem Format-Wechsel. */
    function updateMaterialPrices() {
      var mgi = materialGroupIndex();
      if (mgi === -1) return;
      var sgi = sizeGroupIndex();
      var sel = selectedOptions();
      root.querySelectorAll('.mp-opt--material').forEach(function (card) {
        var input = card.querySelector('input');
        var out = card.querySelector('[data-mp-matprice]');
        if (!input || !out) return;
        var matVal = input.value;
        var best = null;
        variants.forEach(function (v) {
          if (v.options[mgi] !== matVal) return;
          if (sgi !== -1 && sel[sgi] != null && v.options[sgi] !== sel[sgi]) return;
          if (best === null || v.priceCents < best.priceCents) best = v;
        });
        if (best === null) {
          variants.forEach(function (v) {
            if (v.options[mgi] !== matVal) return;
            if (best === null || v.priceCents < best.priceCents) best = v;
          });
        }
        if (best && best.price) out.innerHTML = best.price;
      });
    }

    // Ausgewählte Material-Karte markieren (blauer Rahmen). Nicht auf den CSS-Kombinator
    // „:checked + .mp-matcard" verlassen — der stylt bei dynamischem Wechsel nicht zuverlässig neu.
    function syncMaterialSelected() {
      root.querySelectorAll('.mp-opt--material').forEach(function (label) {
        var inp = label.querySelector('input');
        label.classList.toggle('is-checked', !!(inp && inp.checked));
      });
    }

    function update(pushUrl) {
      var sel = selectedOptions();
      var variant = findVariant(sel);
      updateAvailabilityHints();
      updateSizeNote(sel);
      updateMaterialPrices();
      syncMaterialSelected();

      if (!variant) {
        if (idInput) idInput.value = '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.setAttribute('aria-disabled', 'true'); }
        if (submitText) submitText.textContent = strings.unavailable || 'Nicht verfügbar';
        if (stickyBtn) { stickyBtn.disabled = true; stickyBtn.setAttribute('aria-disabled', 'true'); stickyBtn.textContent = strings.unavailable || 'Nicht verfügbar'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl && variant.price) priceEl.innerHTML = variant.price;
      if (compareEl) {
        if (variant.compareAt) { compareEl.innerHTML = variant.compareAt; compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (submitBtn) {
        if (variant.available && !editionSoldout) {
          submitBtn.disabled = false; submitBtn.removeAttribute('aria-disabled');
          if (submitText) submitText.textContent = strings.addToCart || 'In den Warenkorb';
        } else {
          submitBtn.disabled = true; submitBtn.setAttribute('aria-disabled', 'true');
          if (submitText) submitText.textContent = strings.soldOut || 'Ausverkauft';
        }
      }
      if (stickyBtn) {
        if (variant.available && !editionSoldout) {
          stickyBtn.disabled = false; stickyBtn.removeAttribute('aria-disabled');
          stickyBtn.textContent = strings.addToCart || 'In den Warenkorb';
        } else {
          stickyBtn.disabled = true; stickyBtn.setAttribute('aria-disabled', 'true');
          stickyBtn.textContent = strings.soldOut || 'Ausverkauft';
        }
      }
      // Galerie: Varianten-Bild, sonst Alt-Text-Fallback — Letzterer NUR bei aktiven
      // Wechseln (pushUrl), damit der initiale Seitenaufruf das kuratierte Hero-Bild
      // behält (der Init-Aufruf update(false) darf die Galerie nicht verspringen).
      var galleryMedia = variant.mediaId;
      if (galleryMedia == null && pushUrl) {
        var mgiG = materialGroupIndex();
        if (mgiG !== -1) galleryMedia = galleryMediaForMaterial(sel[mgiG]);
      }
      setGallery(galleryMedia);
      // Nach setGallery filtern, damit das gerade aktivierte Thumb sichtbar bleibt.
      filterThumbs(sel, !pushUrl);
      syncSticky(variant);
      updateBundle();
      if (pushUrl) updateDeepLink(variant);
    }

    /* ---- Bundle (Menge 1/3/5) ---- */
    function updateBundle() {
      var qty = currentBundleQty();
      if (qtyInput) qtyInput.value = qty;
      var sel = selectedOptions();
      var variant = findVariant(sel);
      // Preis-pro-Bild + Gesamt (nur wenn keine echte Rabattlogik → reine Multiplikation, keine erfundene Ersparnis)
      root.querySelectorAll('[data-mp-bundle-total]').forEach(function (el) {
        var q = parseInt(el.getAttribute('data-qty'), 10) || 1;
        if (variant && variant.priceCents != null) {
          el.textContent = window.Shopify && Shopify.formatMoney
            ? Shopify.formatMoney(variant.priceCents * q, window.moneyFormat || '{{amount}} €')
            : '';
        }
      });
      if (stickyVariant && variant) {
        stickyVariant.textContent = variant.title + (qty > 1 ? ' · ' + qty + '×' : '');
      }
    }

    /* ---- Deep-Link beim Laden ---- */
    function applyInitialVariant() {
      var params = new URLSearchParams(window.location.search);
      var vid = params.get('variant');
      if (!vid) return;
      var variant = variants.find(function (v) { return String(v.id) === String(vid); });
      if (!variant) return;
      optionGroups.forEach(function (g, gi) {
        var target = variant.options[gi];
        var input = Array.prototype.find.call(g.querySelectorAll('input'), function (i) { return i.value === target; });
        if (input) input.checked = true;
      });
    }

    optionGroups.forEach(function (g, gi) {
      g.addEventListener('change', function (e) {
        if (e.target && e.target.value != null) snapToValid(gi, e.target.value);
        update(true);
      });
    });
    var bundle = root.querySelector('[data-mp-bundle]');
    if (bundle) bundle.addEventListener('change', function () { updateBundle(); });

    initMaterialUI(root);
    applyInitialVariant();
    applyInitialMaterial(root);
    revealCheckedMaterial(root);
    update(false);
  }

  /* ---- Material: „Weitere Materialien"-Toggle + Vorwahl aus ?material= ---- */
  var MAT_SLUG_TO_VALUE = {
    'leinwand': 'Canvas',
    'acryl': 'Acrylic Print',
    'aluminium': 'Aluminum Print',
    'geb-alu': 'Brushed Aluminum Print',
    'poster-museum-matt': 'Museum-Quality Matte Paper Metal Framed Poster',
    'poster-premium': 'Premium Semi-Glossy Paper Metal Framed Poster',
    'poster-premium-matt': 'Premium Matte Paper Metal Framed Poster',
    'poster-klassisch': 'Classic Semi-Glossy Paper Metal Framed Poster',
    'poster-klassisch-matt': 'Classic Matte Paper Metal Framed Poster'
  };

  function openMaterialSecondary(group) {
    var sec = group.querySelector('[data-mp-mat-secondary]');
    var toggle = group.querySelector('[data-mp-mat-more]');
    if (sec) sec.removeAttribute('hidden');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
  }

  function initMaterialUI(root) {
    var toggle = root.querySelector('[data-mp-mat-more]');
    var sec = root.querySelector('[data-mp-mat-secondary]');
    if (!toggle || !sec) return;
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (open) sec.setAttribute('hidden', ''); else sec.removeAttribute('hidden');
    });
  }

  /* Robin (2026-07-31): Liegt das beim Seitenaufruf gewaehlte Material im
     zugeklappten Bereich, diesen oeffnen. Betrifft vor allem geteilte
     ?variant=-Links auf ein Poster-Material: sonst sieht der Kunde vier
     Materialkarten, keine davon markiert, und seine tatsaechliche Auswahl
     versteckt hinter „Weitere Materialien". applyInitialMaterial macht das
     bereits fuer den ?material=-Pfad — hier fuer alle uebrigen Einstiege. */
  function revealCheckedMaterial(root) {
    var group = root.querySelector('[data-mp-option="material"]');
    if (!group) return;
    var checked = group.querySelector('input:checked');
    if (checked && checked.closest('[data-mp-mat-secondary]')) openMaterialSecondary(group);
  }

  function applyInitialMaterial(root) {
    var params = new URLSearchParams(window.location.search);
    var slug = params.get('material');
    if (!slug) return;
    var value = MAT_SLUG_TO_VALUE[slug];
    if (!value) return;
    var group = root.querySelector('[data-mp-option="material"]');
    if (!group) return;
    var input = Array.prototype.find.call(group.querySelectorAll('input'), function (i) { return i.value === value; });
    if (!input) return; // Produkt bietet dieses Material nicht → still auf Standardvariante bleiben
    input.checked = true;
    // Liegt das Material in der aufklappbaren Gruppe, diese öffnen
    if (input.closest('[data-mp-mat-secondary]')) openMaterialSecondary(group);
    // Change-Event → Snap auf gültige Kombination (z. B. Leinwand braucht Style Slim/Thick) + Update
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* ---- cm/Zoll Umschalter ---- */
  function initUnitToggle(root) {
    var toggle = root.querySelector('[data-mp-unit-toggle]');
    if (!toggle) return;
    toggle.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-unit]');
      if (!btn) return;
      var unit = btn.getAttribute('data-unit');
      toggle.querySelectorAll('[data-unit]').forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
      root.querySelectorAll('[data-cm]').forEach(function (el) {
        var cm = el.getAttribute('data-cm');
        if (unit === 'in') {
          el.textContent = cm.replace(/([0-9]+(?:[.,][0-9]+)?)/g, function (n) {
            var v = parseFloat(n.replace(',', '.')) * CM_TO_IN;
            return (Math.round(v * 10) / 10).toString().replace('.', ',');
          }).replace(/cm/gi, '″');
        } else {
          el.textContent = cm;
        }
      });
    });
  }

  /* ---- Galerie: Thumbs + Zoom ---- */
  function initGallery(gallery) {
    var mainImg = gallery.querySelector('[data-mp-main-img]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-media-id]'));
    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var full = btn.getAttribute('data-full');
        var srcset = btn.getAttribute('data-srcset');
        var alt = btn.getAttribute('data-alt') || '';
        if (mainImg && full) {
          mainImg.src = full;
          if (srcset) mainImg.srcset = srcset;
          mainImg.alt = alt;
          mainImg.setAttribute('data-zoom', btn.getAttribute('data-zoom') || full);
        }
        thumbs.forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-current', 'false'); });
        btn.classList.add('is-active'); btn.setAttribute('aria-current', 'true');
      });
    });
    var opener = gallery.querySelector('[data-mp-zoom-open]');
    if (opener) opener.addEventListener('click', function () { openLightbox(mainImg); });
  }

  function openLightbox(img) {
    if (!img) return;
    var src = img.getAttribute('data-zoom') || img.src;
    var box = document.createElement('div');
    box.className = 'mp-lightbox';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.innerHTML = '<button class="mp-lightbox__close" aria-label="Schließen">&times;</button><img src="' + src + '" alt="' + (img.alt || '') + '">';
    document.body.appendChild(box);
    document.body.style.overflow = 'hidden';
    function close() { box.remove(); document.body.style.overflow = ''; document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    box.addEventListener('click', function (e) { if (e.target === box || e.target.classList.contains('mp-lightbox__close')) close(); });
    document.addEventListener('keydown', onKey);
  }

  /* ---- Sticky-ATC Sichtbarkeit ---- */
  function initSticky() {
    var bar = document.querySelector('[data-mp-sticky]');
    if (!bar) return;
    var anchor = document.querySelector('[data-mp-atc-anchor]');
    if (!anchor || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { bar.classList.toggle('is-visible', !entry.isIntersecting); });
    }, { threshold: 0, rootMargin: '0px 0px -20% 0px' });
    io.observe(anchor);
  }

  function boot() {
    // Galerie ZUERST: initPdp feuert beim ?material=/?variant=-Einstieg synthetische
    // Change-Events, deren setGallery-Thumb-Klick sonst ins Leere geht (Handler
    // noch nicht gebunden) → Bild bliebe auf dem Hero hängen.
    document.querySelectorAll('[data-mp-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-mp-pdp]').forEach(function (root) { initPdp(root); initUnitToggle(root); });
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
